import { Controller } from "@hotwired/stimulus"

// Expanded or Compact, for a figure's options (release_watch/watches/_options):
// shows the one picked and remembers it in this browser for the next figure.
// A link to one listing's tile (#listing_<id>) always opens Expanded, where
// the tile is.
const KEY = "rw-option-view"

export default class extends Controller {
  static targets = [ "choice", "view" ]

  connect() {
    let view = "expanded"
    try { view = localStorage.getItem(KEY) || view } catch {}
    if (location.hash.startsWith("#listing_")) view = "expanded"
    this.show(view)
  }

  pick(event) {
    const view = event.currentTarget.dataset.view
    try { localStorage.setItem(KEY, view) } catch {}
    this.show(view)
  }

  show(view) {
    this.viewTargets.forEach(v => { v.hidden = v.dataset.view !== view })
    this.choiceTargets.forEach(c => {
      c.classList.toggle("is-on", c.dataset.view === view)
      c.setAttribute("aria-pressed", c.dataset.view === view)
    })
  }
}
